import { Text } from '@/components/atoms';
import React, { useEffect, useState } from 'react';
import { ResendOTPIntervalTimeout } from '@/utils/constants';

const ResendOTPInterval = ({ onResendOTP }: { onResendOTP: () => void }) => {
  const [resendOTPInterval, setResendOTPInterval] = useState<number>(
    ResendOTPIntervalTimeout,
  );
  const [intervalId, setIntervalId] = useState<NodeJS.Timer>();

  const decreaseInterval = () => {
    setResendOTPInterval((prevState) => prevState - 1);
  };

  useEffect(() => {
    const intervalId = setInterval(decreaseInterval, 1 * 1000);
    setIntervalId(intervalId);
  }, []);

  useEffect(() => {
    if (resendOTPInterval <= 0) {
      clearInterval(intervalId);
    }
  }, [resendOTPInterval, intervalId]);

  return (
    <>
      {resendOTPInterval > 0 ? (
        <Text
          value={`Send again in 0:${
            resendOTPInterval >= 10
              ? resendOTPInterval
              : '0' + resendOTPInterval
          }`}
          color={'secondary'}
          intent={'text'}
          className="font-bold text-base"
        />
      ) : (
        <Text
          onClick={onResendOTP}
          value="Send again"
          className="font-bold text-base"
          color={'accent'}
          intent={'link'}
        />
      )}
    </>
  );
};

export default ResendOTPInterval;
